import React, { useState } from "react";
import { backendApi } from "../../api/apiService";
import { error } from "jquery";

const HrmsAccess = () => {
  const [accesskey, setAccessKey] = useState("");
  const handleSaveKey = () => {
    const api = {
      functionName: "updateHrmsAccess_key",
      hrms_access_key: accesskey,
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(api)
      .then((data) => {
        if(data.success==="1"){
        alert('Success')
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="row">
      <div className="col-md-4">
        <input
          type="text"
          className="form-control"
          placeholder="Access Key"
          value={accesskey}
          onChange={(e) => setAccessKey(e.target.value)}
        />
      </div>
      <div className="col-md-8">
        <button className="btn btn-primary" onClick={handleSaveKey}>
          Save
        </button>
      </div>
    </div>
  );
};

export default HrmsAccess;
